export const SCHEDA_SERVIZIO_STATE = {
  DA_COMPILARE: 2,
  DISATTIVATA: 4,
  IN_COMPILAZIONE: 21,
  COMPILATA: 22,
  DA_CORREGGERE: 30,
  VALIDATA: 31,
};
